<template>
  <main>
    <div class="d-flex align-items-center text-center bg-body-tertiary main-banner position-relative">
      <div class="w-100 h-100 bg-black bg-opacity-75">
        <div class="col-md-4 p-lg-5 pb-lg-0 mx-auto my-2 bg-banner-text mx-auto">
          <h1 class="display-1 fw-bold text-white">
            <img src="../assets/logo_s.png" alt="Dart Club Wisła Logo" class="img-fluid"/>
          </h1>
          <!--        <div class="d-flex gap-3 justify-content-center lead fw-normal">-->
          <!--          <a class="icon-link" href="#">-->
          <!--            Learn more-->
          <!--            <svg class="bi" aria-hidden="true">-->
          <!--              <use xlink:href="#chevron-right"></use>-->
          <!--            </svg>-->
          <!--          </a>-->
          <!--          <a class="icon-link" href="#">-->
          <!--            Buy-->
          <!--            <svg class="bi" aria-hidden="true">-->
          <!--              <use xlink:href="#chevron-right"></use>-->
          <!--            </svg>-->
          <!--          </a>-->
          <!--        </div>-->
        </div>
        <div class="col-md-6 pb-lg-5 mx-auto bg-banner-text mx-auto">
          <h3 class="fw-normal text-muted pt-3">
            DART
            <font-awesome-icon icon="fa-solid fa-hashtag" class="me-1 text-beige"/>
            DOBRE TOWARZYSTWO
            <font-awesome-icon icon="fa-solid fa-hashtag" class="me-1 text-beige"/>
            RELAKS
          </h3>
        </div>
        <!--      <div class="logo-overlap-container">-->
        <!--        <img src="../assets/logo_s.png" alt="Dart Club Wisła Logo" class="logo-overlap-img"/>-->
        <!--      </div>-->
      </div>
    </div>

    <div class="d-md-flex flex-md-equal w-100 py-md-3 ps-md-3">
      <router-link to="/rezerwacje" class="me-md-3 text-center overflow-hidden bg-reservation-box text-decoration-none border border-1 border-warning-subtle rounded-3">
        <div class="d-flex align-items-center justify-items-center overflow-hidden bg-dark-beige bg-opacity-75 h-100 w-100">
          <div class="my-5 p-5 text-white mx-auto">
            <h2 class="display-5">Rezerwacja online</h2>
            <p class="btn btn-outline-warning btn-lg">Zarezerwuj stanowisko</p>
          </div>
        </div>
      </router-link>
      <router-link to="/stanowiska" class="me-md-3 text-center overflow-hidden bg-plan-box text-decoration-none border border-1 border-warning-subtle rounded-3">
        <div class="d-flex align-items-center justify-items-center overflow-hidden bg-dark-beige bg-opacity-75 h-100 w-100">
          <div class="my-5 p-5 text-white mx-auto">
            <h2 class="display-5">Mapa stanowisk</h2>
            <p class="btn btn-outline-warning btn-lg">Sprawdź</p>
          </div>
        </div>
      </router-link>
    </div>

    <!--    <div class="col-12 my-5">
          <div class="col-12 section-title text-center">
            Wydarzenia
            <hr class="col-3 mx-auto text-warning"/>
          </div>
          <div class="d-md-flex flex-md-equal w-100 p-3">
            <EventsCarousel/>
          </div>
        </div>-->

    <div>
      <div class="text-left bg-body-tertiary bg-bar">
        <div class="col-4 p-5 bar-text bg-dark bg-opacity-75 align-content-center">
          <h1 class="text-body-emphasis">
            Bar
            <hr class="col-6 me-auto text-warning"/>
          </h1>
          <p class="col-lg-12 mx-left lead">
            Zamów chłodny napój dla przyjemniejszej gry lub wrzuć na ruszt małą przekąskę w postaci zapiekanki lub innych przegryzek.
          </p>
        </div>
      </div>
    </div>

  </main>
</template>

<script>
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

export default {
  name: 'MainPage',
  components: {FontAwesomeIcon},
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Cinzel+Decorative:wght@400;700;900&family=Tourney:ital,wght@0,100..900;1,100..900&display=swap');

.main-banner {
  background-image: url('../assets/img/banner_shields.jpg');
  background-size: 130%;
  background-repeat: no-repeat;
  //background-position: 50% 15%;
  animation: slide-bg 40s linear infinite;
}

@keyframes slide-bg {
  0% {
    background-image: url('../assets/img/banner_shields.jpg');
    background-position: 0% 10%; /* Top-left */
  }
  50% {
    background-image: url('../assets/img/banner_shields.jpg');
    background-position: 100% 30%; /* Top-left */
  }
  51% {
    background-image: url('../assets/img/banner_local_back.jpg');
    background-position: 100% 30%; /* Top-left */
  }
  100% {
    background-image: url('../assets/img/banner_local_back.jpg');
    background-position: 0% 40%; /* Bottom-right */
  }
}

.logo-overlap-container {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 50%);
  z-index: 100;
}

.logo-overlap-img {
  width: 140px;
  height: 140px;
  object-fit: contain;
  filter: drop-shadow(0 8px 16px rgba(0, 0, 0, 0.6));
  transition: transform 0.3s ease;
}

.logo-overlap-img:hover {
  transform: scale(1.05);
}

.logo-overlap-container:hover .logo-overlap-img {
  transform: scale(1.08);
}

.bg-banner-text {
  font-family: "Bebas Neue", sans-serif;
  font-weight: 400;
  font-style: normal;
}

.bg-reservation-box {
  background-image: url('../assets/img/banner_reserve.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 25%;

  font-family: "Cinzel Decorative", serif;
  font-weight: 400;
  font-style: normal;
}

.bg-plan-box {
  background-image: url('../assets/img/banner_local.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 25%;

  font-family: "Cinzel Decorative", serif;
  font-weight: 400;
  font-style: normal;
}

.bg-bar {
  background-image: url('../assets/img/bar_with_drinks.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 100% 80%;
  font-family: "Cinzel Decorative", serif;
  font-weight: 400;
  font-style: normal;
}

.bar-text {
  min-height: 400px;
}

.bg-reservation-box, .bg-plan-box {
  transition: box-shadow 0.3s ease;
}

.bg-reservation-box .bg-dark-beige, .bg-plan-box .bg-dark-beige {
  transition: background-color 0.3s ease;
}

.bg-reservation-box .btn, .bg-plan-box .btn {
  transition: background-color 0.3s ease, color 0.3s ease;
}

/* Hover on the parent <a> */
.bg-reservation-box:hover, .bg-plan-box:hover {
  box-shadow: 0px 0px 8px 1px #ffc107;
}

.bg-reservation-box:hover .bg-dark-beige, .bg-plan-box:hover .bg-dark-beige {
  background-color: rgb(46 46 46 / 0.62) !important;
}

/* Hover effect on the button inside the <a> */
.bg-reservation-box:hover .btn, .bg-plan-box:hover .btn {
  background-color: #ffc107;
  color: #212529;
}

.section-title {
  font-family: "Bebas Neue", sans-serif;
  font-size: 2rem;
}
</style>
